import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch, useSessionTimeout } from './shared/hooks';
import { fetchConfig } from './store/slices/configSlice';
import { setFreeAccess, setInitialized } from './store/slices/authSlice';
import { LoginScreen, AdminRoute } from './features/auth';
import { TheaterReservation } from './features/theater';
import { LoadingScreen } from './shared/components';
import './App.css';

function App() {
  const dispatch = useAppDispatch();
  
  // Estados desde Redux
  const { requireAccessCode, loading: configLoading, isInitialized: configInitialized } = useAppSelector(state => state.config);
  const { isAuthenticated, loading: authLoading, isInitialized: authInitialized } = useAppSelector(state => state.auth);

  // Hook para manejo de timeout de sesión
  useSessionTimeout();

  // Cargar configuración al inicializar
  useEffect(() => {
    if (!configInitialized) {
      dispatch(fetchConfig());
    }
  }, [dispatch, configInitialized]);

  // Marcar autenticación como inicializada después de cargar configuración
  useEffect(() => {
    if (configInitialized && !authInitialized) {
      dispatch(setInitialized());
    }
  }, [dispatch, configInitialized, authInitialized]);

  // Manejar acceso libre automático - solo cuando la configuración está cargada y no requiere código
  useEffect(() => {
    if (configInitialized && !configLoading && requireAccessCode === false && !isAuthenticated) {
      dispatch(setFreeAccess());
    }
  }, [dispatch, configInitialized, configLoading, requireAccessCode, isAuthenticated]);

  if (configLoading || !configInitialized || authLoading || !authInitialized) {
    return <LoadingScreen message="Cargando configuración del sistema..." />;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rutas de administración - AdminRoute maneja las subrutas */}
          <Route path="/admin/*" element={<AdminRoute />} />
          
          {/* Ruta principal del teatro */}
          <Route path="/" element={
            !isAuthenticated ? (
              <LoginScreen />
            ) : (
              <TheaterReservation />
            )
          } />
          
          {/* Redirigir cualquier otra ruta a la principal, excepto rutas de admin */}
          <Route path="*" element={
            window.location.pathname.startsWith('/admin') ? (
              <Navigate to="/admin" replace />
            ) : (
              <Navigate to="/" replace />
            )
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;